import React, { Component, Fragment } from 'react';

import { AppStoreButton, PlayStoreButton } from 'components/store-buttons';
import SparkleSimulation from 'components/svg/sparkle-simulation.svg?url';
import { Toggle } from 'components/toggle';
import { I18n } from 'components/translate';
import { UserService } from 'modules/user';
import { PropTypes } from 'prop-types';

import ConfigList from '../components/ConfigList';
import { configStreamingLabels as labels } from '../configStreaming/constants';

import './ConfigSparkle.scss';

export class ConfigSparkle extends Component {
  static propTypes = {
    active: PropTypes.boolean,
    onToggleChange: PropTypes.func
  };

  get language() {
    return UserService.language.toUpperCase();
  }

  render() {
    const sparkleToggleId = 'sparkle__toggle';
    const { active, onToggleChange } = this.props;

    return (
      <Fragment>
        <div className="grid grid__block">
          <h2 className="mb__md">
            <I18n label="config_manager.config_streaming.hotmart_app" />
          </h2>
          <p>
            <I18n
              html
              label="config_manager.config_streaming.hotmart_app_description"
            />
          </p>

          <div className="config__sparkle-campaign__wrapper">
            <div className="config__sparkle-campaign__left-content">
              <ConfigList items={labels.sparkle} />

              <div className="config__sparkle-campaign config__sparkle-campaign__description">
                <p>
                  <I18n
                    html
                    label="config_manager.config_streaming.activate_communication_description_v2"
                  />
                </p>
              </div>

              <div className="config__sparkle-campaign config__sparkle-campaign__activate">
                <label className="title">
                  <I18n label="config_manager.config_streaming.activate_communication_title" />
                </label>
                <div className="config__sparkle-campaign__toggle__wrapper">
                  <div className={sparkleToggleId}>
                    <label className="label__description">
                      <I18n label="config_manager.config_streaming.activate_communication_label_v2" />
                    </label>
                  </div>

                  <Toggle
                    id={sparkleToggleId}
                    name={sparkleToggleId}
                    checked={active}
                    onChange={onToggleChange}
                  />
                </div>
              </div>
            </div>

            <div className="config__sparkle-campaign__image__wrapper">
              <img
                src={SparkleSimulation}
                className="config__sparkle-campaign__image _d-none _d-md-flex"
                alt=""
              />
            </div>
          </div>

          <div className="config__sparkle-campaign config__sparkle-campaign__logo__wrapper">
            <PlayStoreButton language={this.language} />
            <AppStoreButton language={this.language} />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default ConfigSparkle;
